import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Tabs,
  Tab,
  Button,
  Modal,
  Form,
  // ProgressBar,
  InputGroup,
  FormControl,
  ListGroup,
  ListGroupItem,
  Col,
  Row,
  Badge,
  Spinner,
  Image,
} from 'react-bootstrap'
import axios from 'axios'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { WordCloud } from '../components'
import apiServices from '../services/apiServices'

function MissionConfigurator({ setting }) {
  const { channels, banners, websites, show, handleClose } = setting
  const [step, setStep] = useState(0)

  const initMission = {
    useChannel: true,
    channel: {},
    videos: [],
    banners: [],
    gpt_response: '',
    websites: [],
  }
  const [mission, setMission] = useState(initMission)

  const getAccess = async () => {
    const login = await axios({
      url: 'https://nemo.punwave.com/api/v1/login',
      method: 'post',
      data: {
        email: 'hao.liang@wavenet.com.tw',
        password: '1234',
      },
    })
    return login.data.access
  }

  const [cloudResults, setCloudResults] = useState([])
  const getCloud = async (channel_id) => {
    const access = await getAccess()
    const clouds = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_channel_word_cloud',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        channel_id,
      },
    })
    // 假設 clouds.data 為一個陣列，其元素格式 { text: '', value: number }
    setCloudResults(clouds.data.data)
  }

  const [videos, setvideos] = useState([])
  const getVideos = async (channel_id) => {
    const access = await getAccess()
    const res = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_channel_videos_info',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        channel_id,
      },
    })
    setvideos(res.data.data.videos)
  }

  const [searchChannels, setSearchChannels] = useState('')
  const [searchVideos, setSearchVideos] = useState('')
  const [selectedVideos, setSelectedVideos] = useState([])
  const [selectedBanners, setSelectedBanners] = useState({})

  const filteredChannels = channels.filter((c) =>
    Object.keys(c).some(
      (key) =>
        c[key].includes &&
        c[key].toLowerCase &&
        c[key].toLowerCase().includes(searchChannels.toLowerCase())
    )
  )
  const filteredVideos = videos.filter(
    (v) =>
      v.title.toLowerCase().includes(searchVideos.toLowerCase()) ||
      v.gpt_response.importance
        .toLowerCase()
        .includes(searchVideos.toLowerCase()) ||
      v.gpt_response.keywords.some((keyword) =>
        keyword.toLowerCase().includes(searchVideos.toLowerCase())
      )
  )

  const handleToggleBanner = (id) => {
    setSelectedBanners((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const handleConfirmStep1 = () => {
    const selected = mission.useChannel ? mission.channel : selectedVideos
    setMission((prev) => ({
      ...prev,
      videos: mission.useChannel ? [] : selected,
    }))
    setStep(1)
  }

  const handleConfirmStep2 = () => {
    const selectedBannerList = banners.filter(
      (b) => selectedBanners[b.bannerid]
    )
    setMission((prev) => ({
      ...prev,
      banners: selectedBannerList,
    }))
    setStep(2)
  }

  const [score, setscore] = useState({})
  const handleExecuteTask = async (done) => {
    setscore({
      loading: true,
    })
    const res = await apiServices.data({
      path: `quest`,
      method: 'post',
      data: {
        newTask: mission,
        cloud_data: cloudResults,
      },
    })
    setscore({
      complete: true,
      websites: res,
    })
    if (done) {
      handleClose()
    }
  }

  const getVideoCloud = async (video_id) => {
    const access = await getAccess()
    const clouds = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_video_word_cloud',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        video_id,
      },
    })
    return clouds.data.data
    // 假設 clouds.data 為一個陣列，其元素格式 { text: '', value: number }
    // setCloudResults(clouds.data.data)
  }
  const getVideoScore = async () => {
    setscore({
      loading: true,
    })
    const cloud_datas = await Promise.all(
      selectedVideos.map(async (v) => {
        const res = await getVideoCloud(v.id)
        return res
      })
    )
    const res = await apiServices.data({
      path: `quest`,
      method: 'post',
      data: {
        newTask: mission,
        cloud_data: cloud_datas.reduce((prev, cur) => [...prev, ...cur], []),
      },
    })
    setscore({
      complete: true,
      websites: res,
    })
  }

  useEffect(() => {
    if (show.quest_id) {
      setMission(show.setting)
      setStep(2)
      setSelectedVideos(show.setting.videos)
      setSelectedBanners(
        show.setting.banners.reduce(
          (prev, cur) => ({ ...prev, [cur.bannerid]: true }),
          {}
        )
      )
      if (show.setting.results) {
        try {
          setscore({
            complete: true,
            websites: JSON.parse(show.setting.results),
          })
        } catch (e) {
          console.log(e)
        }
      } else {
        setscore({})
      }
    } else {
      setMission(initMission)
      setStep(0)
      setSelectedVideos([])
      setSelectedBanners({})
      setscore({})
    }
  }, [show])

  const handleExecuteExport = async () => {
    const urls = Object.keys(score.websites)
      .filter((key) => score.websites[key].score > 65)
      .map((key) => key)
    if (urls.length) {
      await Promise.all(
        mission.banners.map(async ({ bannerid }) => {
          const res = await apiServices.data({
            path: `revive/${bannerid}/urls`,
            method: 'post',
            data: {
              urls,
            },
          })
          console.log(res)
        })
      )
      alert(`已成功匯入${urls.length}筆紀錄`)
    } else {
      alert(`沒有65分以上的網站！`)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>任務管理器</Modal.Header>
      <Modal.Body>
        {step === 0 &&
          (mission.channel.id ? (
            <>
              <Row>
                <Col xs={8}>
                  <h4>{mission.channel.title}</h4>
                </Col>
                <Col>
                  <Form.Check
                    type="radio"
                    label="使用頻道"
                    name="useMode"
                    checked={mission.useChannel}
                    onChange={() =>
                      setMission({ ...mission, useChannel: true })
                    }
                  />
                </Col>
                <Col>
                  <Form.Check
                    type="radio"
                    label="使用特定影片"
                    name="useMode"
                    checked={!mission.useChannel}
                    onChange={() =>
                      setMission({ ...mission, useChannel: false })
                    }
                  />
                </Col>
              </Row>

              {mission.useChannel ? (
                <WordCloud setting={{ words: cloudResults }} />
              ) : (
                <>
                  <h5>選擇要使用的影片</h5>
                  <InputGroup className="mb-2">
                    <Form.Control
                      placeholder="搜尋影片"
                      value={searchVideos}
                      onChange={(e) => setSearchVideos(e.target.value)}
                    />
                  </InputGroup>

                  <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                    <ListGroup
                      className="overflow-auto"
                      style={{
                        height: '85%',
                        maxHeight: '85%',
                      }}
                    >
                      {filteredVideos.slice(0, 100).map((video) => (
                        <ListGroupItem
                          key={video.id}
                          className="align-items-center"
                          style={{
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            setSelectedVideos((prev) =>
                              prev.includes(video)
                                ? prev.filter((v) => v !== video)
                                : [...prev, video]
                            )
                          }
                          active={selectedVideos.includes(video)}
                          action
                        >
                          <Row>
                            <Col xs={3}>
                              <Image
                                className="w-100"
                                src={video.thumbnail_url}
                              />
                            </Col>
                            <Col>
                              <Row>
                                <Col xs={6}>{video.title}</Col>
                                <Col xs={3}>觀看數：{video.views}</Col>
                                <Col xs={3}>評論數：{video.comments}</Col>
                              </Row>
                              <hr />
                              <Row>
                                <Col xs={2}>簡述</Col>
                                <Col xs={10}>
                                  {video.gpt_response.importance}
                                </Col>
                              </Row>
                              <hr />
                              <Row>
                                <Col xs={2}>關鍵字</Col>
                                <Col xs={10}>
                                  {video.gpt_response.keywords.join()}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </div>
                </>
              )}
              <Button
                className="mt-3 me-2"
                onClick={() => setMission(initMission)}
              >
                選擇其他頻道
              </Button>
              <Button className="mt-3" onClick={handleConfirmStep1}>
                下一步
              </Button>
            </>
          ) : (
            <>
              <h4>請選擇一個頻道</h4>
              <InputGroup className="mb-2">
                <Form.Control
                  placeholder="搜尋頻道"
                  value={searchChannels}
                  onChange={(e) => setSearchChannels(e.target.value)}
                />
              </InputGroup>
              <ListGroup style={{ maxHeight: '300px', overflowY: 'auto' }}>
                {filteredChannels.map((channel) => (
                  <ListGroupItem
                    key={channel.id}
                    onClick={async () => {
                      await getCloud(channel.id)
                      await getVideos(channel.id)
                      setMission((prev) => ({ ...prev, channel }))
                    }}
                    action
                  >
                    {channel.title}
                  </ListGroupItem>
                ))}
              </ListGroup>
              <Button className="mt-3" onClick={handleConfirmStep1}>
                下一步
              </Button>
            </>
          ))}
        {step === 1 && (
          <>
            <h4>確認頻道與影片</h4>
            <p>頻道：{mission.channel.title}</p>
            {!mission.useChannel && (
              <>
                <h5>已選影片</h5>
                <ul>
                  {selectedVideos.map((v) => (
                    <li key={v.id}>{v.title}</li>
                  ))}
                </ul>
              </>
            )}

            <h5>選擇 Banner</h5>
            <ListGroup style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {banners.map((banner) => (
                <ListGroup.Item
                  key={banner.bannerid}
                  onClick={() => handleToggleBanner(banner.bannerid)}
                  active={selectedBanners[banner.bannerid]}
                  action
                >
                  <Row className="align-items-center">
                    {/* 名稱／描述 (已交換) */}
                    <Col xs={7}>
                      <Row>
                        <Col xs={12}>
                          <strong>名稱：</strong>
                          {banner.description}
                        </Col>
                        <Col xs={12}>
                          <Row>
                            <Col xs={2}>
                              <strong>ID：</strong>
                              {banner.bannerid}
                            </Col>
                            <Col>
                              <strong>描述：</strong>
                              {banner.filename}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    {/* 最後更新 */}
                    <Col xs={4}>
                      <strong>最後更新：</strong>
                      <div>
                        <small>
                          {new Date(banner.updated).toLocaleString('zh-TW', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                          })}
                        </small>
                      </div>
                    </Col>
                  </Row>
                </ListGroup.Item>
              ))}
            </ListGroup>

            <Button className="mt-3 me-2" onClick={() => setStep(0)}>
              返回修改
            </Button>
            <Button className="mt-3" onClick={handleConfirmStep2}>
              下一步
            </Button>
          </>
        )}
        {step === 2 && (
          <>
            <Row className="mb-3">
              <Col>
                <h4>預覽任務</h4>
              </Col>
              <Col className="d-flex">
                <Button
                  className="my-auto ms-auto"
                  variant="success"
                  onClick={
                    mission.useChannel
                      ? () => handleExecuteTask()
                      : () => getVideoScore()
                  }
                >
                  預覽結果
                </Button>
                {score.complete && (
                  <Button
                    className="my-auto ms-2"
                    variant="success"
                    onClick={handleExecuteExport}
                  >
                    立刻匯入
                  </Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  <strong>頻道：</strong>
                  {mission.channel.title}
                </p>
                {!mission.useChannel && (
                  <>
                    <h5>選擇的影片</h5>
                    <ul>
                      {selectedVideos.map((v) => (
                        <li key={v.id}>{v.title}</li>
                      ))}
                    </ul>
                  </>
                )}
                <h5>包含的 Banner</h5>
                <ul>
                  {banners
                    .filter((b) => selectedBanners[b.bannerid])
                    .map((b) => (
                      <li key={b.bannerid}>
                        {b.bannerid}：{b.description}
                      </li>
                    ))}
                </ul>
              </Col>
              <Col>
                {score.loading && (
                  <div className="d-flex mt-auto justify-content-center">
                    <Spinner
                      className="my-auto"
                      animation="border"
                      size="sm"
                      style={{
                        animation: 'spinner-border 1.5s linear infinite',
                      }}
                    />
                    <h5 className="text-dai fs-4 my-auto ms-2">
                      資料載入中...
                    </h5>
                  </div>
                )}
                {score.complete && (
                  <ListGroup>
                    <ListGroupItem className="d-flex flex-nowrap">
                      <Col xs={8}>網站</Col>
                      <Col xs={4}>分數</Col>
                    </ListGroupItem>
                    {Object.keys(score.websites).map((key) => (
                      <ListGroupItem key={key}>
                        <Row className="border-bottom">
                          <Col xs={8}>
                            {
                              websites.find((wb) => wb.url === key)?.setting[
                                '標題'
                              ]
                            }
                          </Col>
                          <Col xs={4}>{score.websites[key].score}</Col>
                        </Row>
                        <Row className="border-bottom">
                          <Col xs={2}>網址</Col>
                          <Col>{key}</Col>
                        </Row>
                        <Row>
                          <Col xs={2}>理由</Col>
                          <Col>{score.websites[key].reason}</Col>
                        </Row>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                )}
              </Col>
            </Row>

            <Button className="mt-3 me-2" onClick={() => setStep(1)}>
              返回修改
            </Button>
            <Button
              className="mt-3 ms-2"
              variant="primary"
              onClick={() => handleExecuteTask(true)}
            >
              確定送出
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}

function CreatorSonar() {
  const [channels, setChannels] = useState([])
  const [cloudModalVisible, setCloudModalVisible] = useState(false)
  const [cloudResults, setCloudResults] = useState([]) // array of cloud items
  const [currentChannelId, setCurrentChannelId] = useState(null)
  const [searchChannels, setSearchChannels] = useState('')
  const [searchVideos, setSearchVideos] = useState('')
  const [revive, setrevive] = useState({
    campaigns: [],
    banners: [],
    insights: {},
    zones: [],
    clients: [],
    az: [],
  })
  const { banners } = revive
  const getRevive = async () => {
    const res = await apiServices.data({
      path: `revive`,
      method: 'get',
    })
    setrevive(res)
  }
  useEffect(() => {
    getRevive()
  }, [])

  const getAccess = async () => {
    const login = await axios({
      url: 'https://nemo.punwave.com/api/v1/login',
      method: 'post',
      data: {
        email: 'hao.liang@wavenet.com.tw',
        password: '1234',
      },
    })
    return login.data.access
  }

  const getVideoCloud = async (video_id) => {
    const access = await getAccess()
    const clouds = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_video_word_cloud',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        video_id,
      },
    })
    return clouds.data.data
    // 假設 clouds.data 為一個陣列，其元素格式 { text: '', value: number }
    // setCloudResults(clouds.data.data)
  }

  const getCloud = async (channel_id) => {
    const access = await getAccess()
    const clouds = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_channel_word_cloud',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        channel_id,
      },
    })
    // 假設 clouds.data 為一個陣列，其元素格式 { text: '', value: number }
    setCloudResults(clouds.data.data)
  }

  const getChannels = async () => {
    const access = await getAccess()
    const res = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_channels',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
    })
    setChannels(res.data.data)
  }

  const [videos, setvideos] = useState([])
  const getVideos = async (channel_id) => {
    const access = await getAccess()
    const res = await axios({
      url: 'https://nemo.punwave.com/api/v1/get_channel_videos_info',
      method: 'get',
      headers: {
        Authorization: `Bearer ${access}`,
      },
      params: {
        channel_id,
      },
    })
    setvideos(res.data.data.videos)
  }

  useEffect(() => {
    getChannels()
    // getVideos()
  }, [])

  // 使用 state 儲存 tab 目前所選擇的 key，預設為「任務列表」(quests)
  const [activeTab, setActiveTab] = useState('quests')

  // 狀態：任務列表
  const [quests, setQuests] = useState([])
  // 狀態：網站資源
  const [websites, setWebsites] = useState([])

  // 搜尋用狀態
  const [searchQuests, setSearchQuests] = useState('')
  const [searchWebsites, setSearchWebsites] = useState('')

  // 新增任務 modal 是否顯示
  const [modalVisible, setModalVisible] = useState(false)
  // 新增任務的物件狀態，包含 youtubeId, status, result
  const initNewTask = {
    youtubeId: '',
    status: '',
    result: {},
  }
  const [newTask, setNewTask] = useState(initNewTask)
  // 任務執行進度百分比
  const [progress, setProgress] = useState(0)
  console.log(progress)

  // 空的 getquests 函數
  const getquests = async () => {
    const res = await apiServices.data({ path: `quest`, method: 'get' })
    setQuests(res)
  }

  // 空的 getwebsites 函數
  const getwebsites = async () => {
    const res = await apiServices.data({ path: `website`, method: 'get' })
    setWebsites(res)
  }

  // 當 activeTab 改為 quests 時
  useEffect(() => {
    if (activeTab === 'quests') {
      getquests()
    }
  }, [activeTab])

  // 當 activeTab 改為 websites 時
  useEffect(() => {
    if (activeTab === 'websites') {
      getwebsites()
    }
  }, [activeTab])

  const handleAddTask = () => {
    setModalVisible(true)
  }

  const handleModalClose = () => {
    setModalVisible(false)
    setNewTask({ youtubeId: '', status: '', result: {} })
    setProgress(0)
  }

  const [score, setscore] = useState({})
  const [videoScore, setvideoScore] = useState({})
  const handleExecuteTask = async () => {
    setscore({
      loading: true,
    })
    const res = await apiServices.data({
      path: `quest`,
      method: 'post',
      data: {
        newTask,
        cloud_data: cloudResults,
      },
    })
    setscore({
      complete: true,
      websites: res,
    })
    getquests()
    setNewTask((prev) => ({ ...prev, status: '執行中' }))
    // let prog = 0
    // const intervalId = setInterval(() => {
    //   prog += 10
    //   setProgress(prog)
    //   if (prog >= 100) {
    //     clearInterval(intervalId)
    //     setNewTask((prev) => ({ ...prev, status: '完成' }))
    //   }
    // }, 500)
  }

  // 篩選條件
  const filteredQuests =
    quests && quests.filter
      ? quests.filter((q) => (q.name || '').includes(searchQuests))
      : []
  const filteredWebsites =
    websites && websites.filter
      ? websites.filter((w) => (w.url || '').includes(searchWebsites))
      : []
  const filteredChannels =
    channels && channels.filter
      ? channels.filter((c) => (c.title || '').includes(searchChannels))
      : []
  const filteredVideos =
    videos && videos.filter
      ? videos.filter((v) => (v.title || '').includes(searchVideos))
      : []

  // 當按下「顯示文字雲」時，開啟 modal 並呼叫 getCloud
  const handleShowCloud = async (channel_id) => {
    setCurrentChannelId(channel_id)
    await getCloud(channel_id)
    await getVideos(channel_id)
    setCloudModalVisible(true)
  }

  const handleCloudModalClose = () => {
    setCloudModalVisible(false)
    setCloudResults([])
    setCurrentChannelId(null)
  }

  const [exporting, setexporting] = useState({
    show: false,
    target: {},
  })
  const handleExport = async () => {
    setexporting({
      ...exporting,
      show: true,
    })
  }
  const handleExecuteExport = async () => {
    const res = await apiServices.data({
      path: `revive/83/urls`,
      method: 'post',
      data: {
        urls: exporting.target,
      },
    })
    console.log(res)
  }

  const handleDeleteQuest = async (id) => {
    const res = await apiServices.data({
      path: `quest/${id}`,
      method: 'delete',
    })
    console.log(res)
    getquests()
  }

  // const [mission, setmission] = useState({
  //   useChannel: true,
  //   channel_id: '',
  //   video_ids: [],
  //   banners: [],
  //   gpt_response: '',
  //   websites: [],
  // })

  return (
    <div className="container mt-3 py-3 px-5 h-100 d-flex flex-column">
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        id="my-tabs"
        className="mb-3"
      >
        <Tab eventKey="quests" title="任務列表">
          <div className="h-100 d-flex flex-column">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="搜尋任務"
                value={searchQuests}
                onChange={(e) => setSearchQuests(e.target.value)}
              />
            </InputGroup>
            <Button variant="primary" onClick={handleAddTask}>
              新增任務
            </Button>
            <div
              className="mt-3"
              style={{
                height: '95%',
                maxHeight: '95%',
              }}
            >
              <div className="h-100 d-flex flex-column">
                <ListGroup>
                  <ListGroupItem className="d-flex flex-nowrap text-center border-end">
                    <Col xs={2}>任務ID</Col>
                    <Col xs={4}>Youtube ID</Col>
                    <Col xs={4}>狀態與結果</Col>
                    <Col xs={2}>操作</Col>
                  </ListGroupItem>
                </ListGroup>
                {filteredQuests.length ? (
                  <ListGroup
                    className="overflow-auto"
                    style={{
                      height: '75%',
                      maxHeight: '75%',
                    }}
                  >
                    {filteredQuests.map((fq) => (
                      <ListGroupItem
                        className="d-flex flex-nowrap"
                        key={fq.quest_id}
                      >
                        <Col xs={2} className="d-flex border-end">
                          <p className="m-auto text-center">{fq.quest_id}</p>
                        </Col>
                        <Col xs={4} className="d-flex border-end">
                          <p className="m-auto text-center">
                            {fq.setting.channel
                              ? fq.setting.channel.title
                              : fq.setting.youtubeId}
                          </p>
                        </Col>
                        <Col xs={4} className="d-flex border-end">
                          <p className="m-auto text-center">
                            {fq.setting.status || '已完成'}
                          </p>
                        </Col>
                        <Col className="d-flex">
                          <Button
                            className="my-auto ms-auto"
                            onClick={() => setModalVisible(fq)}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </Button>
                          <Button
                            variant="danger"
                            className="my-auto me-auto ms-2"
                            onClick={() => handleDeleteQuest(fq.quest_id)}
                          >
                            <FontAwesomeIcon icon={faTrashAlt} />
                          </Button>
                        </Col>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                ) : (
                  <p>沒有任務</p>
                )}
              </div>
            </div>
          </div>
        </Tab>
        <Tab eventKey="websites" title="網站資源">
          <div className="h-100 d-flex flex-column">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="搜尋網站"
                value={searchWebsites}
                onChange={(e) => setSearchWebsites(e.target.value)}
              />
            </InputGroup>
            <div
              className="mt-3"
              style={{
                height: '95%',
                maxHeight: '95%',
              }}
            >
              <div className="h-100 d-flex flex-column">
                {filteredWebsites.length ? (
                  <ListGroup
                    className="overflow-auto"
                    style={{
                      height: '85%',
                      maxHeight: '85%',
                    }}
                  >
                    {filteredWebsites
                      .filter((fw) => fw.setting['標題'])
                      .map((fw) => (
                        <ListGroupItem
                          className="text-start rounded border"
                          key={fw.website_id}
                        >
                          <Row className="border-bottom py-2">
                            <Col className="text-start fw-bold">
                              {fw.setting['標題'] || fw.url}
                            </Col>
                            <Col className="text-end">
                              最後更新：
                              {moment(fw.updated_on).format('MM-DD HH:MM')}
                            </Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col xs={2} className="fw-bold">
                              網址
                            </Col>
                            <Col className="text-end">{fw.url}</Col>
                          </Row>
                          <Row className="border-bottom py-2">
                            <Col xs={2} className="fw-bold">
                              摘要
                            </Col>
                            <Col>{fw.setting['內文']}</Col>
                          </Row>
                          <Row className="py-2">
                            <Col xs={2} className="fw-bold">
                              關鍵字
                            </Col>
                            <Col>
                              {fw.setting['關鍵字']?.split
                                ? fw.setting['關鍵字']
                                    .split(', ')
                                    .map((keyword) => (
                                      <Badge key={keyword} className="me-1">
                                        {keyword}
                                      </Badge>
                                    ))
                                : (
                                    fw.setting['關鍵字'] ||
                                    fw.setting.keywords ||
                                    []
                                  ).map((keyword) => (
                                    <Badge key={keyword} className="me-1">
                                      {keyword}
                                    </Badge>
                                  ))}
                            </Col>
                          </Row>
                        </ListGroupItem>
                      ))}
                  </ListGroup>
                ) : (
                  <p>沒有網站資源</p>
                )}
              </div>
            </div>
          </div>
        </Tab>
        <Tab eventKey="yt" title="YT資源">
          <div className="h-100 d-flex flex-column">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="搜尋頻道"
                value={searchChannels}
                onChange={(e) => setSearchChannels(e.target.value)}
              />
            </InputGroup>
            <div
              className="mt-3"
              style={{
                height: '95%',
                maxHeight: '95%',
              }}
            >
              <div className="h-100 d-flex flex-column">
                <ListGroup>
                  <ListGroupItem className="d-flex flex-nowrap">
                    <Col xs={3}>頻道名稱</Col>
                    <Col xs={3}>影片數</Col>
                    <Col xs={3}>讚數</Col>
                    <Col xs={2}>評論數</Col>
                    <Col xs={1}>操作</Col>
                  </ListGroupItem>
                </ListGroup>
                {filteredChannels.length ? (
                  <ListGroup
                    className="overflow-auto"
                    style={{
                      height: '85%',
                      maxHeight: '85%',
                    }}
                  >
                    {filteredChannels.slice(0, 100).map((channel) => (
                      <ListGroupItem
                        key={channel.id}
                        className="d-flex flex-nowrap align-items-center"
                      >
                        <Col xs={3}>{channel.title}</Col>
                        <Col xs={3}>{channel.videos}</Col>
                        <Col xs={3}>{channel.likes}</Col>
                        <Col xs={2}>{channel.comments}</Col>
                        <Col xs={1}>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowCloud(channel.id)}
                          >
                            顯示文字雲
                          </Button>
                        </Col>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                ) : (
                  <p>沒有頻道資料</p>
                )}
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>

      <MissionConfigurator
        setting={{
          show: modalVisible,
          handleClose: handleModalClose,
          channels,
          banners,
          websites,
        }}
      />

      {/* 新增任務 Modal */}
      <Modal show={false} onHide={handleModalClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>新增任務</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            minHeight: '75vh',
          }}
        >
          <Form>
            <Form.Group className="d-flex" controlId="youtubeId">
              <Form.Label>
                {newTask.title ? newTask.title : '請選擇一個頻道'}
              </Form.Label>
              {/* <Form.Control
                type="text"
                placeholder="請輸入 YouTube ID"
                value={newTask.youtubeId}
                onChange={(e) =>
                  setNewTask({ ...newTask, youtubeId: e.target.value })
                }
              /> */}
              {newTask.title && (
                <Button
                  variant="primary"
                  onClick={() => setNewTask(initNewTask)}
                  className="my-3 ms-auto me-2"
                >
                  返回列表
                </Button>
              )}
            </Form.Group>
            {newTask.youtubeId && (
              <WordCloud setting={{ words: cloudResults }} />
            )}
            {score.loading && (
              <div className="d-flex mt-auto justify-content-center">
                <Spinner
                  className="my-auto"
                  animation="border"
                  size="sm"
                  style={{
                    animation: 'spinner-border 1.5s linear infinite',
                  }}
                />
                <h5 className="text-dai fs-4 my-auto ms-2">資料載入中...</h5>
              </div>
            )}
            {score.complete && (
              <ListGroup>
                <ListGroupItem className="d-flex flex-nowrap">
                  <Col xs={6}>網站</Col>
                  <Col xs={6}>分數</Col>
                </ListGroupItem>
                {Object.keys(score.websites).map((key) => (
                  <ListGroupItem className="d-flex flex-nowrap" key={key}>
                    <Col xs={6}>{key}</Col>
                    <Col xs={6}>{score.websites[key]}</Col>
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
            <Row className="my-3">
              <Col xs={9}>
                <Button
                  variant="primary"
                  onClick={handleExecuteTask}
                  disabled={!newTask.youtubeId}
                >
                  執行任務
                </Button>
              </Col>
              <Col xs={2}>
                {score.complete && (
                  <Button
                    variant="primary"
                    onClick={handleExport}
                    className="ms-3"
                    // disabled={!newTask.youtubeId}
                  >
                    選擇匯入對象
                  </Button>
                )}
              </Col>
              <Col xs={1}>
                {exporting.show && (
                  <Button
                    variant="primary"
                    onClick={handleExecuteExport}
                    className="ms-auto"
                    // disabled={!newTask.youtubeId}
                  >
                    匯入
                  </Button>
                )}
              </Col>
            </Row>
            {exporting.show && (
              <ListGroup
                className="mb-3"
                style={{ height: '300px', overflowY: 'auto' }}
              >
                {banners.map((banner) => (
                  <ListGroup.Item key={banner.bannerid}>
                    <Row className="align-items-center">
                      {/* 名稱／描述 (已交換) */}
                      <Col xs={7}>
                        <Row>
                          <Col xs={12}>
                            <strong>名稱：</strong>
                            {banner.description}
                          </Col>
                          <Col xs={12}>
                            <Row>
                              <Col xs={2}>
                                <strong>ID：</strong>
                                {banner.bannerid}
                              </Col>
                              <Col>
                                <strong>描述：</strong>
                                {banner.filename}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>

                      {/* 最後更新 */}
                      <Col xs={4}>
                        <strong>最後更新：</strong>
                        <div>
                          <small>
                            {new Date(banner.updated).toLocaleString('zh-TW', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                            })}
                          </small>
                        </div>
                      </Col>

                      {/* 勾選框 */}
                      <Col xs={1} className="text-center">
                        <Form.Check
                          type="checkbox"
                          checked={exporting.target[banner.bannerid]}
                          onChange={() =>
                            setexporting({
                              ...exporting,
                              target: {
                                ...exporting.target,
                                [banner.bannerid]:
                                  !exporting.target[banner.bannerid],
                              },
                            })
                          }
                          aria-label={`選取 banner ${banner.bannerid}`}
                        />
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
            {/* <div className="mt-3">
              <ProgressBar now={progress} label={`${progress}%`} />
            </div> */}
          </Form>
          {newTask.youtubeId ? (
            <div
              className="d-flex flex-column"
              style={{
                height: '500px',
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  placeholder="搜尋影片"
                  value={searchVideos}
                  onChange={(e) => setSearchVideos(e.target.value)}
                />
              </InputGroup>
              <div
                className="mt-3"
                style={{
                  height: '95%',
                  maxHeight: '95%',
                }}
              >
                <div className="h-100 d-flex flex-column">
                  <h4>頻道影片</h4>
                  <ListGroup
                    className="overflow-auto"
                    style={{
                      height: '85%',
                      maxHeight: '85%',
                    }}
                  >
                    {filteredVideos.slice(0, 100).map((video) => (
                      <ListGroupItem
                        key={video.id}
                        className="align-items-center"
                        onClick={async () => {
                          setvideoScore({
                            active: video.id,
                            loading: true,
                          })
                          const cloud_data = await getVideoCloud(video.id)
                          const res = await apiServices.data({
                            path: `quest`,
                            method: 'post',
                            data: {
                              newTask: {
                                ...video,
                              },
                              cloud_data,
                            },
                          })
                          setvideoScore({
                            active: video.id,
                            complete: true,
                            websites: res,
                          })
                          // await getCloud(channel.id)
                          // await getVideos(channel.id)
                          // setNewTask({
                          //   ...newTask,
                          //   ...channel,
                          //   youtubeId: channel.id,
                          // })
                        }}
                        action
                      >
                        <Row>
                          <Col xs={3}>
                            <Image
                              className="w-100"
                              src={video.thumbnail_url}
                            />
                          </Col>
                          <Col>
                            <Row>
                              <Col xs={6}>{video.title}</Col>
                              <Col xs={3}>觀看數：{video.views}</Col>
                              <Col xs={3}>評論數：{video.comments}</Col>
                            </Row>
                            <hr />
                            <Row>
                              <Col xs={2}>簡述</Col>
                              <Col xs={10}>{video.gpt_response.importance}</Col>
                            </Row>
                            <hr />
                            <Row>
                              <Col xs={2}>關鍵字</Col>
                              <Col xs={10}>
                                {video.gpt_response.keywords.join()}
                              </Col>
                            </Row>
                            {videoScore.active === video.id && (
                              <Row>
                                {videoScore.loading && (
                                  <div className="d-flex mt-auto justify-content-center">
                                    <Spinner
                                      className="my-auto"
                                      animation="border"
                                      size="sm"
                                      style={{
                                        animation:
                                          'spinner-border 1.5s linear infinite',
                                      }}
                                    />
                                    <h5 className="text-dai fs-4 my-auto ms-2">
                                      資料載入中...
                                    </h5>
                                  </div>
                                )}
                                {videoScore.complete && (
                                  <ListGroup>
                                    <ListGroupItem className="d-flex flex-nowrap">
                                      <Col xs={6}>網站</Col>
                                      <Col xs={6}>分數</Col>
                                    </ListGroupItem>
                                    {Object.keys(videoScore.websites).map(
                                      (key) => (
                                        <ListGroupItem
                                          className="d-flex flex-nowrap"
                                          key={key}
                                        >
                                          <Col xs={6}>{key}</Col>
                                          <Col xs={6}>
                                            {videoScore.websites[key]}
                                          </Col>
                                        </ListGroupItem>
                                      )
                                    )}
                                  </ListGroup>
                                )}
                              </Row>
                            )}
                          </Col>
                        </Row>
                        {/* <Col xs={1}>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowCloud(channel.id)}
                          >
                            顯示文字雲
                          </Button>
                        </Col> */}
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              </div>
            </div>
          ) : (
            <div
              className="d-flex flex-column"
              style={{
                height: '500px',
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  placeholder="搜尋頻道"
                  value={searchChannels}
                  onChange={(e) => setSearchChannels(e.target.value)}
                />
              </InputGroup>
              <div
                className="mt-3"
                style={{
                  height: '95%',
                  maxHeight: '95%',
                }}
              >
                <div className="h-100 d-flex flex-column">
                  <ListGroup>
                    <ListGroupItem className="d-flex flex-nowrap">
                      <Col xs={3}>頻道名稱</Col>
                      <Col xs={3}>影片數</Col>
                      <Col xs={3}>讚數</Col>
                      <Col xs={2}>評論數</Col>
                      <Col xs={1}>操作</Col>
                    </ListGroupItem>
                  </ListGroup>
                  {filteredChannels.length ? (
                    <ListGroup
                      className="overflow-auto"
                      style={{
                        height: '85%',
                        maxHeight: '85%',
                      }}
                    >
                      {filteredChannels.slice(0, 100).map((channel) => (
                        <ListGroupItem
                          key={channel.id}
                          className="d-flex flex-nowrap align-items-center"
                          onClick={async () => {
                            await getCloud(channel.id)
                            await getVideos(channel.id)
                            setNewTask({
                              ...newTask,
                              ...channel,
                              youtubeId: channel.id,
                            })
                          }}
                          action
                        >
                          <Col xs={4}>{channel.title}</Col>
                          <Col xs={3}>{channel.videos}</Col>
                          <Col xs={3}>{channel.likes}</Col>
                          <Col xs={2}>{channel.comments}</Col>
                          {/* <Col xs={1}>
                          <Button
                            variant="info"
                            size="sm"
                            onClick={() => handleShowCloud(channel.id)}
                          >
                            顯示文字雲
                          </Button>
                        </Col> */}
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  ) : (
                    <p>沒有頻道資料</p>
                  )}
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>

      {/* YT資源文字雲 Modal */}
      <Modal show={cloudModalVisible} onHide={handleCloudModalClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {currentChannelId
              ? channels.find(({ id }) => id === currentChannelId).title
              : ''}
            的文字雲
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {cloudResults && cloudResults.length ? (
            <ListGroup>
              <WordCloud setting={{ words: cloudResults }} />
              {cloudResults.map((item, index) => (
                <ListGroupItem key={index}>
                  <Row>
                    <Col xs={8}>{item.text}</Col>
                    <Col xs={4}>
                      <Badge>{item.value.toFixed(2)}</Badge>
                    </Col>
                  </Row>
                </ListGroupItem>
              ))}
            </ListGroup>
          ) : (
            <p>無文字雲資料</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloudModalClose}>
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

MissionConfigurator.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default CreatorSonar
